import * as Api from '@ViewModels';
import { stringify as stringifyQueryParams } from 'query-string';
import { TemplateType } from '../../../../../extViewmodels';
import { ILocationState } from '../../../../../models';
import { CampaignType } from '../../../../../models/AdminModels';
import { useEventLogging } from '../../../../../models/Logging';
import { useAdminUserSession } from '../../../../../models/hooks/adminStateHooks';
import { useFullscreenModal } from '../../../../../models/hooks/appStateHooks';
import {
	IndustryHtmlNewsletterViewModel,
	TemplateCategoriesViewModel,
	TemplateEditViewModel,
	TemplateWithStatusesViewModel,
} from '../../../../../viewmodels/AdminViewModels';
import { DropdownItem } from '../../../../../web/components-v2/Dropdown';

interface Props {
	campaignType: CampaignType;
	template: TemplateWithStatusesViewModel;
	categories: TemplateCategoriesViewModel;
	categoryName?: string;
	industry: Api.Industry;
}

export function TemplateCategoryEditDropdownItem({
	campaignType,
	template,
	categories,
	categoryName,
	industry,
}: Props) {
	const userSession = useAdminUserSession();
	const fullscreenModal = useFullscreenModal();
	const { logInput } = useEventLogging('TemplateCategoryEditMoreMenuItem');
	const handleClick = async () => {
		logInput('EditAction', 'Click', {
			id: template.templateReference.template.id,
		});
		const associatedTemplate = new TemplateEditViewModel(userSession);
		if (campaignType === CampaignType.Social && template.templateReference.template?.associatedTemplates?.length > 0) {
			await associatedTemplate?.load(
				template.templateReference.template?.associatedTemplates[0]?.id,
				CampaignType.Email
			);
		}
		const comboTemplate =
			campaignType === CampaignType.Social && template.templateReference.template?.associatedTemplates?.length > 0
				? new TemplateWithStatusesViewModel(userSession, associatedTemplate.getSystemTemplate(), industry)
				: template;
		categories.categories?.forEach(x => x.setExpanded(false));
		if (
			categoryName === IndustryHtmlNewsletterViewModel.HtmlNewslettersCategoryName ||
			template.templateReference.template.templateType === TemplateType.HtmlNewsletter
		) {
			const locationState: ILocationState<IndustryHtmlNewsletterViewModel, any> = {
				viewModel: new IndustryHtmlNewsletterViewModel(userSession, template.templateReference),
			};

			fullscreenModal?.history?.push({
				pathname: '/campaign-templates/html-newsletter/edit',
				state: locationState,
			});
		} else if (
			campaignType === CampaignType.Social &&
			template.templateReference.template?.associatedTemplates?.length > 0
		) {
			const socialCategories = new TemplateCategoriesViewModel(userSession, industry, CampaignType.Social);

			const locationState: ILocationState<TemplateCategoriesViewModel, TemplateWithStatusesViewModel> = {
				model: comboTemplate,
				viewModel: socialCategories,
			};
			fullscreenModal?.history?.push({
				pathname: '/campaign-templates/email/edit',
				search: stringifyQueryParams({ fromSocial: true }),
				state: locationState,
			});
		} else if (campaignType === CampaignType.Email) {
			const locationState: ILocationState<TemplateCategoriesViewModel, TemplateWithStatusesViewModel> = {
				model: comboTemplate,
				viewModel: categories,
			};

			fullscreenModal?.history?.push({
				pathname: '/campaign-templates/email/edit',
				state: locationState,
			});
		} else if (campaignType === CampaignType.Blog) {
			const blogTemplateCategoriesVm = new TemplateCategoriesViewModel(userSession, industry, CampaignType.Blog);

			const locationState: ILocationState<TemplateCategoriesViewModel, TemplateWithStatusesViewModel> = {
				model: template,
				viewModel: blogTemplateCategoriesVm,
			};
			const id = template.templateReference.template.id;
			fullscreenModal?.history?.push({
				pathname: `/campaign-templates/blog-post/edit/${id}`,
				state: locationState,
			});
		} else {
			const locationState: ILocationState<TemplateCategoriesViewModel, TemplateWithStatusesViewModel> = {
				model: template,
				viewModel: categories,
			};
			fullscreenModal?.history?.push({
				pathname: '/campaign-templates/social/edit',
				state: locationState,
			});
		}
	};
	return <DropdownItem onClick={handleClick}>Edit</DropdownItem>;
}
